import personalizeService from '../utils/rbmc.personalizeService';
import pdpLoadProduct from '../pdp/rbmc.pdp-load-product';
import pdpAddToCart from '../pdp/rbmc.pdp-add-to-cart';
import cartCounter from '../header/rbmc.cart-counter';
import consumerEvents from '../events/rbmc.events.consumer-events';
import cartTracking from '../tracking/rbmc.tracking.cart';
import landingPageSlider from '../components/rbmc.subshop-slider.js';
import gigyaLiteRegistration from '../gigya/rbmc.lite-registration';
import gigyaCustom from '../gigya/rbmc.gigya';
import accordionPage from '../components/rbmc.faq-item';

window.rbBridge = {
    cart:        {
        updateCounter: cartCounter.updateCounter
    },
    gigya:       {
        fetchSubscriptionData:    gigyaLiteRegistration.fetchSubscriptionData,
        renderGlobalMessages:     gigyaCustom.renderGlobalMessages,
        CDC_PENDING_SUBSCRIPTION: gigyaLiteRegistration.CDC_PENDING_SUBSCRIPTION,
        triggerDoiResend:         gigyaLiteRegistration.triggerDoiResend
    },
    personalize: {
        getPersonalizedData:  personalizeService.getPersonalizedData,
        requestCountryChange: personalizeService.requestCountryChange
    },
    product:     {
        addToCart:       pdpAddToCart.addToCartArchibald,
        loadProductData: pdpLoadProduct.loadProductData,
        refreshMiniCart: pdpAddToCart.refreshMiniCart,
    },
    tracking:    {
        trackAddToCartGTM:     cartTracking.addToCart,
        trackAddToCartProfile: consumerEvents.trackAddToCartEvent,
        countComponents:       function (selector) {
            return document.querySelectorAll(selector).length.toString();
        }
    },
    util:        {
        buildArcSubshopSlider:  landingPageSlider.buildArcSubshopSlider,
        openAccordionCollapse:  accordionPage.openCollapse,
        closeAccordionCollapse: accordionPage.closeCollapse,
    }
};
